import { createBrowserHistory } from "history";
export const sharedHistory = createBrowserHistory();
